export default __webpack_public_path__ + "static/media/inner-page-header-02.08081228.png";